import { Component, Input, Renderer2 } from '@angular/core';
import { AgGridDataModelTransactionHistoryList } from './transaction-history.model';
import { AgGridI } from 'src/app/shared/common-components/ag-grid/ag-grid.model';
import { AgGridService } from 'src/app/shared/common-components/ag-grid/ag-grid.service';
import { Subscription } from 'rxjs';
import { RowClassRules, RowHeightParams } from 'ag-grid-community';
import { TransactionService } from 'src/app/components/transaction/transaction.service';
import { PaymentVoucherList } from 'src/app/components/transaction/transaction.model';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss']
})
export class TransactionHistoryComponent {
  agGridDataModelTransactionHistoryList: AgGridI;
  textClickSubscriptionForTab: Subscription;
  onDeleteRowClickedSubscription: Subscription;
  customerUserId: string;
  @Input() displayHeader = true;
  @Input() isFilter = true;
  gridApi: any;
  paymentVoucherList = new PaymentVoucherList()
  totalRecords: number
  rowData = [
  ];

  constructor(
    public renderer: Renderer2,
    public agGridService: AgGridService,
    public transactionService: TransactionService,
    public storageService: StorageService,
    public toaster: ToastrService,
  ) { }

  ngOnInit(): void {
    this.agGridDataModelTransactionHistoryList = AgGridDataModelTransactionHistoryList;
    this.textClickSubscriptionForTab = this.agGridService.onTextClicked$.subscribe((params) => {
      const data = params?.data;
      this.cellClicked(data);
    });
    this.customerUserId = this.storageService.retrieve("userId");
    this.getAllPaymentVoucherData()
  }

  onGridReady(params) {
    this.gridApi = params;
    this.agGridDataModelTransactionHistoryList.showPagination = true;
    this.paymentVoucherList.getAll = false;
    this.paymentVoucherList.pageNumber = 1;

  }

  cellClicked(event: any) {
    this.showExpandebleComponent(event);
  }

  public rowClassRules: RowClassRules =
    {
      "row-border": (params) => {
        return params.data.isExpandable == true;
      },
      "expandable-grid": (params) => {
        return params.data.isExpandable == true;
      },
    };

  getRowHeight(params: RowHeightParams): number | undefined | null {
    return params.data.isExpandable ? 225 : 27;
  }

  showExpandebleComponent(event) {
    const clickedData = event;
    let expanded = 0;
    let data = this.gridApi.api?.getModel().rowsToDisplay;
    data.map((value) => {
      if (value.data.isExpandable) {
        expanded++;
      }
    });
    clickedData.isExpandable = !clickedData.isExpandable;
    this.gridApi.api.redrawRows();
  }

  getAllPaymentVoucherData() {
    this.paymentVoucherList.id =this.customerUserId;
    this.transactionService.getAllPaymentVoucher(this.paymentVoucherList).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.gridApi?.api?.setRowData(res?.response?.data);
          this.totalRecords = res.totalRecords;
        } else {
          this.toaster.error(res.message);
          this.rowData = [];
          this.totalRecords = res.totalRecords;
        }
      },
      error: (err) => {
        this.toaster.error(err?.error?.message);
          this.gridApi?.api?.setRowData([]);
      }
    })
  }

  onChnagePage(event) {
    this.paymentVoucherList.pageNumber=event?.pageNumber;
    this.paymentVoucherList.pageSize=event?.pageSize;
    this.paymentVoucherList.getAll = this?.paymentVoucherList?.pageSize === 1;
    this.getAllPaymentVoucherData()
  }


}
